import RefreshIcon from "@mui/icons-material/Refresh";
import {
  Box,
  Grid,
  Link,
  styled,
  Switch,
  Tooltip
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { ReactComponent as CreateIcon } from "../../../src/assets/USA_Images/CreateIcon.svg";
import DataTableLatest from "../../components/DataTable/DataTableLatest";
import HeaderToolbar from "../../components/HeaderToolbar";
import {
  getAllVisitorType,
  updateVisitorType,
} from "../../slices/VisitorType/VisitorTypeSlice";
import { ThemeContext } from "../../theme/ThemeContext";
import FilterChecklistTemplate from "../ChecklistTemplateUSA/FilterChecklistTemplate";
import EditIcon from "../Person/EditIcon";
import AddVisitorType from "./AddVisitorType";
import VisitorTypeView from "./VisitorTypeView";

export default function VisitorType(props) {
  const [clear, setClear] = React.useState(false);
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [totalRecords, setTotalRecords] = useState(1);
  const [rows, setRows] = useState([]);
  const { darkMode, setDiaLogBoxBlur } = useContext(ThemeContext);

  const Android12Switch = styled(Switch)(({ mode, theme }) => ({
    padding: 8,
    "& .MuiSwitch-track": {
      borderRadius: 22 / 2,
      border: "1px solid #888B8D",
      backgroundColor: mode ? "#888B8D" : "white",
    },
    "& .MuiSwitch-thumb": {
      backgroundColor: "#888B8D",
      boxShadow: "none",
      width: 16,
      height: 16,
      margin: 2,
      position: "relative",
      "&:before": {
        content: '""',
        position: "absolute",
        top: "50%",
        transform: "translateY(-50%)",
        width: 16,
        height: 16,
      },
    },
    "& .MuiButtonBase-root.MuiSwitch-switchBase.Mui-checked .MuiSwitch-thumb": {
      backgroundColor: "#fff", // Change thumb color when checked
      "&:after": {
        content: '""',
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "60%",
        height: "60%",
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="8" height="5.97" viewBox="0 0 8 5.97"><path fill="%23226BAB" d="M17.772,14.911l-3.381,3.381-1.353-1.352a.956.956,0,0,0-1.352,1.352l2.03,2.029a.955.955,0,0,0,1.352,0l4.057-4.057a.956.956,0,1,0-1.352-1.352Z" transform="translate(-11.405 -14.63)"/></svg>')`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundSize: "contain",
      },
    },
    "& .MuiButtonBase-root.MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
      backgroundColor: "#226BAB !important",
      opacity: 1,
    },
  }));

  const [paging, setPaging] = useState({
    page: 1,
    rowsPerPage: 50,
  });

  const [filter, setFilter] = React.useState({
    id: "",
    name: "",
  });

  const defaultFilter = {
    id: "",
    name: "",
  };

  const handleChange = (newPage, size) => {
    setPage(newPage);
    setPaging({
      page: newPage,
      rowsPerPage: size,
    });
  };

  useEffect(() => {
    loadData(filter, paging);
  }, [filter, paging, clear]);

  const handleOpen = () => {
    setOpen(true);
    setDiaLogBoxBlur(true);
  };

  const resetFilter = () => {
    setClear(false);
    setPaging({ ...paging, page: 1 });
    setFilter(defaultFilter);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const loadData = (filter, paging) => {
    dispatch(getAllVisitorType(Object.assign(filter, paging)))
      .unwrap()
      .then((data) => {
        if (data.code === "CVAI0000" && data.data) {
          setTotalRecords(data.data.totalCount);
          setPage(data.data.curPage);
          setTotalPages(data.data.totalPages);
          setRows(data.data.visitorTypes);
        } else {
          setRows([]);
        }
      })
      .catch((er) => { });
  };

  const handleFilter = (data) => {
    setClear(true);
    setPaging({ ...paging, page: 1 });
    setFilter({
      name: data.name,
    });
  };

  const [selectedObject, setSelectedObject] = useState({
    id: "",
    companyId: "",
    name: "",
    description: "",
  });

  const handleVisitorTypeStatusChange = (event, params) => {
    const updateVisitorTypeData = {
      id: params.id,
      name: params.name,
      description: params.description,
      status: params.status === "ACTIVE" ? "INACTIVE" : "ACTIVE",
      opType: params.status === "ACTIVE" ? "Disable" : "Enable",
    };
    dispatch(updateVisitorType(updateVisitorTypeData))
      .unwrap()
      .then((data) => {
        if (data.code === "CVAI0039") {
          loadData(filter, paging);
        }
      });
  };

  const handleEditVisitPurposeType = (params) => {
    setOpenEditDialog(!openEditDialog);
    setSelectedObject(params);
    setDiaLogBoxBlur(true);
  };

  const columns = React.useMemo(() => [
    {
      headerName: "",
      sortable: false,
      width: 5,
      renderCell: (params) => {
        return <div></div>;
      },
    },
    {
      field: "name",
      headerName: t("accessLevelName"),
      flex: 1,
      width: 110,
      valueGetter: (params) => params.row.name,
    },

    {
      field: "description",
      headerName: t("ATYPE009"),
      flex: 1,
      minWidth: 290,
      valueGetter: (params) => params.row.description,
    },

    {
      field: "Actions",
      headerName: t("ACTION"),
      type: "actions",
      flex: 1,
      minWidth: 165,
      width: 150,
      headerAlign: "center",
      getActions: (params) => [
        <VisitorTypeView title={t("VISITORTYPED")} rowData={params.row} />,
        <Box onClick={() => handleEditVisitPurposeType(params.row)}>
          <EditIcon />
        </Box>,
        <Tooltip
          title={params.row.status === "ACTIVE" ? t("DISABLE") : t("ENABLE")}
        >
          <Android12Switch
            checked={params.row.status === "ACTIVE"}
            onChange={(event) =>
              handleVisitorTypeStatusChange(event, params.row)
            }
            mode={darkMode}
          />
        </Tooltip>,
      ],
    },
  ]);

  return (
    <>
      <HeaderToolbar title={t("COMMON068")} />
      <Box
        display={"flex"}
        width={"100%"}
        flexDirection={"row-reverse"}
        alignItems={"center"}
        style={{
          gap: "8px",
          padding: "10px 0px 10px 10px",
        }}
      >
        <Box item>
          {clear && (
            <Link
              href="#"
              underline="hover"
              className="line"
              style={{
                opacity: "0.8",
                color: "#E3393C",
                fontSize: "14px",
                underline: "hover",
                display: "inline",
              }}
              onClick={resetFilter}
            >
              {t("CLEARFILTER")}
            </Link>
          )}
        </Box>
        <Tooltip title={t("ADD032")}>
          <Grid item className={"addIcon"} onClick={handleOpen}>
            <CreateIcon />
          </Grid>
        </Tooltip>
        <Tooltip title={t("COMMON002")}>
          <Box item className="refreshIcon">
            <RefreshIcon onClick={() => loadData(filter, paging)} />
          </Box>
        </Tooltip>
        <Box item>
          <FilterChecklistTemplate
            rowsPerPage={rowsPerPage}
            applyFilter={(data) => handleFilter(data)}
          />
        </Box>
      </Box>
      <div style={{ height: 300, width: "100%" }}>
        <DataTableLatest
          columns={columns}
          rows={rows}
          page={page}
          count={totalRecords}
          rowId={(row) => row.id}
          pageCount={totalPages}
          pageSize={rowsPerPage}
          handleChange={(newPage, size) => handleChange(newPage, size)}
        />
      </div>
      {open && (
        <AddVisitorType
          open={open}
          selectedObject={selectedObject}
          handleClose={() => {
            handleClose(loadData(filter, page));
            setDiaLogBoxBlur(false);
          }}
        />
      )}

      {openEditDialog && (
        <AddVisitorType
          selectedObject={selectedObject}
          open={openEditDialog}
          handleClose={() => {
            setOpenEditDialog(false);
            setDiaLogBoxBlur(false);
            setSelectedObject({
              id: "",
              companyId: "",
              name: "",
              description: "",
            });
            loadData(filter, paging);
          }}
        />
      )}
    </>
  );
}
